import { render } from "./FellowTitle.vue?vue&type=template&id=ab357d24"
import script from "./FellowTitle.vue?vue&type=script&lang=js"
export * from "./FellowTitle.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src739691156/src/fellow/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__